module.exports = __webpack_public_path__ + "static/media/Troll-Selected.35ea1782.png";